<template>
  <div class="modal unlogined" :class="{ active: showModal }">
    <div class="container unlogined-container">
      <div class="unlogined__title">Доступ ограничен</div>
      <div class="unlogined__text">
        К сожалению, вы не можете войти в приложение, так как в базе отсутствуют
        сведения о том, что вы являетесь членом или сторонником партии. Если вы
        считаете, что это ошибка, пожалуйста, свяжитесь с технической
        поддержкой:
        <span @click.prevent="copyText">
          vpshplus@edinros.ru
          <CopyIcon />
          <div v-show="showSugg" class="unlogined__sugg">Адрес скопирован</div>
        </span>
      </div>
      <div class="unlogined-buttons">
        <ButtonEl @click="closeModal">Закрыть</ButtonEl>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonEl from '@/components/blocks/buttons/ButtonEl.vue';
import CopyIcon from '@/components/icons/CopyIcon.vue';
const PLATFORM = window?.WebApp?.initDataUnsafe?.user?.id
  ? 'MAX'
  : window?.Telegram?.WebApp?.initDataUnsafe?.user?.id
  ? 'TELEGRAM'
  : null;

export default {
  name: 'UnloginedModal',
  components: {
    ButtonEl,
    CopyIcon,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: false,
      showSugg: false,
    };
  },
  mounted() {
    this.showModal = this.show;
  },
  watch: {
    show() {
      this.showModal = this.show;
    },
  },
  methods: {
    closeModal() {
      if (PLATFORM === 'MAX') {
        if (window?.WebApp) {
          window.WebApp.close();
        }
      } else if (PLATFORM === 'TELEGRAM') {
        if (window?.Telegram?.WebApp) {
          window.Telegram.WebApp.close();
        }
      }
    },
    copyText() {
      navigator.clipboard.writeText('vpshplus@edinros.ru').then(() => {
        this.showSugg = true;
        setTimeout(() => {
          this.showSugg = false;
        }, 2000);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.unlogined {
  height: 100%;
  &-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
  &__title {
    color: var(--color-black);
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 125%;
  }

  &__text {
    color: var(--color-black);
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: normal;
    line-height: 125%;

    span {
      color: var(--color-blue);
      text-decoration: none;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      position: relative;
    }
  }
  &__sugg {
    position: absolute;
    width: 160px;
    background-color: var(--color-blue);
    border-radius: 6px;
    padding: 4px;
    bottom: 22px;
    right: 0;
    color: var(--color-white);
    font-size: 14px;
    font-style: normal;
    font-weight: normal;
    line-height: 100%;
    display: block;
    transition: 0.3s all ease-in-out;
  }
}
</style>
